import {$http} from '@utils'
import queryString from 'query-string'
import api from '@utils/api'
export default {
    namespaced: true,
    state:{
        roleList:[],
        roleListCount:0,
    },
    mutations:{
        queryRole(state,payload){
            if(!payload.data){
                payload = {
                    ...payload,
                    data:[],
                    count:0
                }
            } else if(payload.data.length>0&&!payload.data[0]) {
                payload = {
                    ...payload,
                    data:[],
                    count:0
                }
            }
            // console.table(payload.data)
            state.roleList = payload.data
            state.roleListCount = payload.count
        }
    },
    actions:{
        async queryRole ({commit},{params}) {
            const res = await $http.get(`${api.mainHost}${api.mainContentPath}/role/queryRole.do?${queryString.stringify(params)}`);
            if (res.code * 1 === 1) {
                commit('queryRole', res)
            } else {
                console.log(res.msg)
            }
        },
    }
}